export default __webpack_public_path__ + "static/media/doubleDotsVertical.f9fdf6c2.svg";